import React, { Component } from 'react'

class CustomTextArea extends Component {
  constructor (props) {
    super(props)
    this.state = {
      height: '34px'
    }

    this.resize = this.resize.bind(this)
    this.delayedResize = this.delayedResize.bind(this)
    this.blurIt = this.blurIt.bind(this)
  }

  blurIt () {
    this.setState({ height: '34px' })
  }

  resize (event) {
    this.setState({ height: event.target.scrollHeight + 'px' })
  }

  delayedResize (event) {
    window.setTimeout(this.resize.bind(this), 0, event)
  }

  componentDidMount () {
    this.textArea.addEventListener('change', this.resize, false)
    this.textArea.addEventListener('cut', this.delayedResize, false)
    this.textArea.addEventListener('paste', this.delayedResize, false)
    this.textArea.addEventListener('drop', this.delayedResize, false)
    this.textArea.addEventListener('keydown', this.delayedResize, false)
    this.textArea.addEventListener('focus', this.delayedResize, false)
    this.textArea.addEventListener('blur', this.blurIt, false)
  }

  componentWillUnmount () {
    this.textArea.removeEventListener('change', this.resize, false)
    this.textArea.removeEventListener('cut', this.delayedResize, false)
    this.textArea.removeEventListener('paste', this.delayedResize, false)
    this.textArea.removeEventListener('drop', this.delayedResize, false)
    this.textArea.removeEventListener('keydown', this.delayedResize, false)
    this.textArea.removeEventListener('focus', this.delayedResize, false)
    this.textArea.removeEventListener('blur', this.blurIt, false)
  }

  render () {
    return (
      <textarea
        ref={textarea => {
          this.textArea = textarea
        }}
        {...this.props}
        style={{ height: this.state.height }}
      />
    )
  }
}

export default CustomTextArea



// WEBPACK FOOTER //
// ./src/components/form/textarea/index.js